<h3>{{ title }}</h3>

<table mat-table [dataSource]="dataSource" matSort matSortActive="name" matSortDirection="asc" matSortDisableClear>
    <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
            {{ 'files.list.name.shortLabel' | translate }} </th>
        <td mat-cell *matCellDef="let file"> {{ file.name }} </td>
    </ng-container>

    <ng-container matColumnDef="source">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
            {{ 'files.list.source.shortLabel' | translate }} </th>
        <td mat-cell *matCellDef="let file"> {{ file.source.text.shortLabel }} </td>
    </ng-container>

    <ng-container matColumnDef="type">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
            {{ 'files.list.type.shortLabel' | translate }} </th>
        <td mat-cell *matCellDef="let file"> {{ file.type.text.shortLabel }} </td>
    </ng-container>

    <ng-container matColumnDef="editedOn">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
            {{ 'files.list.editedOn.shortLabel' | translate }} </th>
        <td mat-cell *matCellDef="let file"> {{ file.editedOn | date }} </td>
    </ng-container>

    <ng-container matColumnDef="uploadedBy">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
            {{ 'files.list.uploadedBy.shortLabel' | translate }} </th>
        <td mat-cell *matCellDef="let file"> {{ file.uploadedBy || systemName }} </td>
    </ng-container>

    <ng-container matColumnDef="uploadedOn">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
            {{ 'files.list.uploadedOn.shortLabel' | translate }} </th>
        <td mat-cell *matCellDef="let file"> {{ file.uploadedOn | date }} </td>
    </ng-container>

    <ng-container matColumnDef="select">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
            {{ 'parameters.fileSelect.shortLabel' | translate }} </th>
        <td mat-cell *matCellDef="let file">
            <button mat-button class="action-button"
                [color]="isSelected(file.id) && selectedFileIds ? 'accent' : 'primary'"
                [disabled]="!selectedFileIds || isLoading"
                *ngIf="isSelected(file.id)"
                (click)="onSelect(file)">
                <mat-icon aria-label="Selected">check_circle</mat-icon>
                {{ 'parameters.fileSelected.shortLabel' | translate }}
            </button>
            <button mat-button class="action-button" color="accent"
                *ngIf="!isSelected(file.id)"
                [disabled]="isLoading"
                (click)="onSelect(file)">
                <mat-icon aria-label="Select">check_circle_outline</mat-icon>
                {{ 'parameters.select.shortLabel' | translate }}
            </button>
        </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let file; columns: displayedColumns;"></tr>
</table>
